import {Provider} from '@angular/core';

import {VerifyAuthUseCasePort} from '@features/auth/application/use_cases/verify-auth/verify-auth.use-case.port';

import {VerifyAuthUseCase} from '@features/auth/application/use_cases/verify-auth/verify-auth.use-case';
import {AuthHttpAdapterProvider} from '@features/auth/infrastructure/http/auth.http.adapter.provider';

export const VerifyAuthUseCaseProvider: Provider[] = [
  AuthHttpAdapterProvider,
  {
    provide: VerifyAuthUseCasePort,
    useClass: VerifyAuthUseCase
  }
];
